"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addDataKeys;

var _init = _interopRequireDefault(require("../_core/init"));

var _defineprop = _interopRequireDefault(require("../_core/defineprop"));

var _seempleerror = _interopRequireDefault(require("../_helpers/seempleerror"));

var _foreach = _interopRequireDefault(require("../_helpers/foreach"));

var _triggerone = _interopRequireDefault(require("../trigger/_triggerone"));

// adds keys to a list of data keys
function addDataKeys(givenKeys) {
  var _this = this;

  var _initSeemple = (0, _init["default"])(this),
      keys = _initSeemple.keys;

  var newKeys; // accept an array keys or a list of args

  if (givenKeys instanceof Array) {
    newKeys = givenKeys;
  } else {
    newKeys = arguments;
  }

  (0, _foreach["default"])(newKeys, function (key) {
    if (typeof key !== 'string') {
      throw (0, _seempleerror["default"])('adddatakeys:key_type', {
        key: key
      });
    } // if key is not in a list of keys


    if (!(key in keys)) {
      // define descriptors for this property
      var _defineProp = (0, _defineprop["default"])(_this, key),
          value = _defineProp.value;

      var eventOptions = {
        key: key,
        value: value
      }; // add a key to the list of keys

      keys[key] = true; // trigger events which say that data is changed

      (0, _triggerone["default"])(_this, 'set', eventOptions);
      (0, _triggerone["default"])(_this, 'modify', eventOptions);
    }
  });
  return this;
}
//# sourceMappingURL=adddatakeys.js.map